<template>
    <span>
        <button
            class="btn btn-sm is-primary"
            @click="$modal.show(`add-email-account-alias-${emailAccount.id}`)"
        >
            + {{ lang('Lägg till alias','Add alias') }}
        </button>

        <form-modal
            :title="lang('Lägg till alias','Add alias')"
            :name="`add-email-account-alias-${emailAccount.id}`"
            method="post"
            :primary-button-text="lang('Spara','Save')"
            :close-button-text="lang('Avbryt','Cancel')"
            :action="route('front.my-pages.api.email-accounts.aliases.store', emailAccount)"
            :callback="handleResponse"
            :hide-when-done="true"
        >
            <div>
                <p>
                    {{ lang('För e-postkontot','For e-mail account') }}: {{ emailAccount.address }}
                </p>

                <p class="mb-2xl">
                    {{ lang(
                        'Här skapar du alias för din e-postadress (du kan ha flera, men lägger till ett i taget).',
                        'You can create an alias for your e-mail address here (you can create several, but add one at a time).'
                    ) }}
                    {{ lang(
                        'Ett alias kan vara en alternativ stavning eller annan variant av din e-post.',
                        'An alias can be an alternative spelling or variant of your e-mail'
                    ) }}
                </p>

                <div class="flex flex-col md:flex-row items-center mb-lg">
                    <div class="w-full">
                        <text-input
                            :label="lang('Alias','Alias')"
                            type="text"
                            name="email_username"
                            :required="true"
                            :autofocus="true"
                        />
                    </div>
                    <div class="text-lg mx-xl mb-xl">@</div>
                    <div class="w-full">
                        <div class="textfield-select">
                            <select-input
                                name="products"
                                :options="domainOptions"
                                :value="emailAccount.domain"
                                :disabled="true"
                            >
                                {{ lang('Domän','Domain') }}
                            </select-input>
                        </div>
                    </div>
                </div>
            </div>
        </form-modal>
    </span>
</template>

<script>
    export default {
        props: {
            emailAccount: {
                type: Object,
                required: true,
            },
            domainOptions: {
                type: Array,
                required: true,
            },
        },

        methods: {
            handleResponse(response) {
                flash_success(lang('Aliaset tillagt.', 'The alias was added.'));

                this.$emit('aliasAdded', response.data);
            },
        },
    };
</script>